import * as React from "react";
import { COLOR } from '../utils/variables';
import './styles.scss';
var Sidebar = function (props) {
    return (React.createElement("div", { className: "side-menu-container", style: { background: props.sideMenuBgColor ? props.sideMenuBgColor : COLOR.WHITE } },
        React.createElement("div", { className: "side-menu" }, React.Children.toArray(props.children)
            .filter(Boolean)
            .map(function (child, index) {
            return React.cloneElement(child, {
                key: index,
                firstchild: 1,
            });
        }))));
};
export default Sidebar;
//# sourceMappingURL=index.js.map